import { render, staticRenderFns } from "./FilterPillsRow.vue?vue&type=template&id=496742be&scoped=true&"
import script from "./FilterPillsRow.vue?vue&type=script&lang=ts&"
export * from "./FilterPillsRow.vue?vue&type=script&lang=ts&"
import style0 from "./FilterPillsRow.vue?vue&type=style&index=0&id=496742be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496742be",
  null
  
)

export default component.exports